<template>

</template>

<script>
export default {

  mounted: function () {
    console.log('hha')
    let code = this.$route.query.code
    let redirect = this.$auth.redirect()
    this.$auth.loginback({
      data: {
        code: code
      },
      redirect: redirect ? redirect.from.name : '/',
      fetchUser: this.fetchUser
    })
    .then((res) => {
      // FIXME: ElementUI is required to use $message, need to find a replacement
      this.$message(res.data.message)
    })
    .catch((error) => {
      if (error.response.data.status === 'unconfirmed') {
        this.$refs.modalUnconfirmed.show()
      } else {
        this.$message(error.response.data.message)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
